(function() {
    'use strict';

    angular.module('user', [
            'ui.router',

            'user.constants',
            'user.services'
        ])
        .config(tokenInterceptor)
        .config(uiRouting)
        .run(checkPermissions)
        .run(checkModelPermissions);

    tokenInterceptor.$inject = ['$httpProvider'];

    function tokenInterceptor($httpProvider) {
        $httpProvider.interceptors.push('tokenInterceptor');
    }

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'adminPermissionsConst', 'clientPermissionsConst', 'modelPermissionsGroupPermissionsConst', 'allowedIpPermissionsConst', 'discountGroupPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, adminPermissionsConst, clientPermissionsConst, modelPermissionsGroupPermissionsConst, allowedIpPermissionsConst, discountGroupPermissionsConst) {
        $stateProvider
            .state('login', {
                abstract: true,
                views: {
                    'content@': {
                        templateUrl: 'app/user/views/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Logowanie',
                    permission: userPermissionsConst.anonymous
                }
            })
            .state('login.username', {
                url: '/login',
                views: {
                    'form@login': {
                        templateUrl: 'app/user/views/login-username/login-username.html',
                        controller: 'LoginUsernameController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('login.barcode', {
                url: '/login/barcode',
                views: {
                    'form@login': {
                        templateUrl: 'app/user/views/login-barcode/login-barcode.html',
                        controller: 'LoginBarcodeController',
                        controllerAs: 'ctrl'
                    }
                }
            });

        $stateProvider
            .state('layout.admin', {
                abstract: true,
                url: '/admins',
                data: {
                    title: 'Użytkownicy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.admin.list', {
                url: '/list?is_active',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/admin-list/admin-list.html',
                        controller: 'AdminListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: adminPermissionsConst.view
                }
            })
            .state('layout.admin.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/admin-create/admin-create.html',
                        controller: 'AdminCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: adminPermissionsConst.add
                }
            })
            .state('layout.admin.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/admin-update/admin-update.html',
                        controller: 'AdminUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: adminPermissionsConst.update
                }
            })
            .state('layout.admin.barcode', {
                url: '/barcode/:pk',
                views: {
                    'content@': {
                        templateUrl: 'app/user/views/admin-barcode/admin-barcode.html',
                        controller: 'AdminBarcodeController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    bodyClass: 'barcode-view'
                }
            });

        $stateProvider
            .state('layout.client', {
                abstract: true,
                url: '/clients',
                data: {
                    title: 'Klienci',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.client.list', {
                url: '/list?is_active',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/client-list/client-list.html',
                        controller: 'ClientListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientPermissionsConst.view
                }
            })
            .state('layout.client.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/client-create/client-create.html',
                        controller: 'ClientCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientPermissionsConst.add
                }
            })
            .state('layout.client.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/client-update/client-update.html',
                        controller: 'ClientUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientPermissionsConst.update
                }
            })
            .state('layout.client.details', {
                url: '/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/client-details/client-details.html',
                        controller: 'ClientDetailsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.modelPermissionsGroup', {
                abstract: true,
                url: '/groups',
                data: {
                    title: 'Grupy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.modelPermissionsGroup.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/model-permissions-group-list/model-permissions-group-list.html',
                        controller: 'ModelPermissionsGroupListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: modelPermissionsGroupPermissionsConst.view
                }
            })
            .state('layout.modelPermissionsGroup.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/model-permissions-group-create/model-permissions-group-create.html',
                        controller: 'ModelPermissionsGroupCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: modelPermissionsGroupPermissionsConst.add
                }
            })
            .state('layout.modelPermissionsGroup.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/model-permissions-group-update/model-permissions-group-update.html',
                        controller: 'ModelPermissionsGroupUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: modelPermissionsGroupPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.allowedIp', {
                abstract: true,
                url: '/ips',
                data: {
                    title: 'Dozwolone adresy IP',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.allowedIp.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/allowed-ip-list/allowed-ip-list.html',
                        controller: 'AllowedIpListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: allowedIpPermissionsConst.view
                }
            })
            .state('layout.allowedIp.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/allowed-ip-create/allowed-ip-create.html',
                        controller: 'AllowedIpCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: allowedIpPermissionsConst.add
                }
            })
            .state('layout.allowedIp.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/allowed-ip-update/allowed-ip-update.html',
                        controller: 'AllowedIpUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: allowedIpPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.discountGroup', {
                abstract: true,
                url: '/discount-groups',
                data: {
                    title: 'Grupy rabatowe',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.discountGroup.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/discount-group-list/discount-group-list.html',
                        controller: 'DiscountGroupListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: discountGroupPermissionsConst.view
                }
            })
            .state('layout.discountGroup.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/discount-group-create/discount-group-create.html',
                        controller: 'DiscountGroupCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: discountGroupPermissionsConst.add
                }
            })
            .state('layout.discountGroup.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/user/views/discount-group-update/discount-group-update.html',
                        controller: 'DiscountGroupUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: discountGroupPermissionsConst.update
                }
            });
    }

    checkPermissions.$inject = ['$rootScope', 'checkPermissionsSrvc'];

    function checkPermissions($rootScope, checkPermissionsSrvc) {
        $rootScope.$on('$stateChangeStart', checkPermissionsSrvc.check);
    }

    checkModelPermissions.$inject = ['$rootScope', 'checkModelPermissionsSrvc'];

    function checkModelPermissions($rootScope, checkModelPermissionsSrvc) {
        $rootScope.$on('$stateChangeStart', checkModelPermissionsSrvc.check);
    }
})();
